// custom typefaces
import './src/styles/prism-vsc-dark-plus.scss';
import './src/styles/normalize.scss';
import './src/styles/global.scss';
